var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickShipper(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.87 23.09v-6.5l-5.72-2.45v6.5l5.72 2.45zM23.92 23.09l5.72-2.45v-6.5l-5.72 2.44v6.51zM29.64 12.99l-6.25-2.66-6.24 2.66v.02l6.24 2.66 6.25-2.66v-.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 9.85v14.3a2.91 2.91 0 01-1.38 2.37l-12.26 7.14a2.9 2.9 0 01-2.73 0L6.36 26.52C5.58 26.06 5 25.03 5 24.15V9.85a2.96 2.96 0 011.36-2.37L18.64.34a2.9 2.9 0 012.73 0l12.27 7.14c.78.46 1.36 1.49 1.36 2.37zM8.12 12.84h6.42v1.04H8.12v-1.04zm2.26 3.47h4.16v1.04h-4.16v-1.04zm20.3-4v9.02l-7.29 3.1-7.28-3.1v-9.02l7.28-3.11 7.3 3.1-.01.01zM9.34 19.44h5.21v1.04H9.34v-1.04z"
  })));
}

export default SvgQuickShipper;